import React from 'react';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {DesktopDatePicker} from "@mui/x-date-pickers";

interface Props {
    label: string;
    value?: Date | null;
    onChange?: (date: Date | null) => void;
}

const DatePickerComponent: React.FC<Props> = ({ label, value, onChange }) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
                label={label}
                value={value}
                onChange={onChange}
                slotProps={{
                    textField: {
                        variant: 'outlined',
                        fullWidth: true,
                    },
                }}
                sx={{
                    "& .MuiInputBase-root": {
                        backgroundColor: "white",   // <-- force white input background
                    },
                    "& .MuiFormLabel-asterisk": { color: "red" },
                }}
            />
        </LocalizationProvider>
        // <LocalizationProvider dateAdapter={AdapterDateFns}>
        //     <DatePicker
        //         label={label}
        //         value={value}
        //         onChange={onChange}
        //         slotProps={{
        //             textField: {
        //                 variant: 'outlined',
        //                 sx: {
        //                     width: '100%',
        //                     '& .MuiInputBase-root': {
        //                         height: 'auto',
        //                     },
        //                     '& .MuiInputLabel-root': {
        //                         whiteSpace: 'nowrap',
        //                         overflow: 'visible',
        //                     },
        //                 },
        //             },
        //         }}
        //     />
        // </LocalizationProvider>
    );
};

export default DatePickerComponent;